export default {
  data() {
    return {
      currentOrg: {
        id: "",
        name: "全部",
        orgType: 1,
        fullPathId: "",
      },
      searchContent: "",
      pageIndex: 1,
      pageSize: 12,
      total: 0,
      tableData: [],
      multipleSelection: [],
      editDisable: true,
      deleteDisable: true,
      dialogAddVisible: false,
      addForm: {
        name: "",
        orgType: "1",
        orgTypes: [
          {
            name: "机构",
            value: "1",
          },
          {
            name: "部门",
            value: "2",
          },
          {
            name: "岗位",
            value: "3",
          },
        ],
      },
      dialogEditVisible: false,
      editForm: {
        id: "",
        name: "",
        orgType: "1",
        orgTypes: [
          {
            name: "机构",
            value: "1",
          },
          {
            name: "部门",
            value: "2",
          },
          {
            name: "岗位",
            value: "3",
          },
        ],
      },
      tree: null,
    };
  },
  mounted: function () {
    this.requestTreeData();
    this.requestOrgList();
  },
  methods: {
    clickEvent: function (from) {
      switch (from) {
        case "add": //新增
          this.dialogAddVisible = true;
          switch (this.currentOrg.orgType) {
            case 1: //机构
              this.addForm.orgType = "1";
              this.addForm.orgTypes = [
                {
                  name: "机构",
                  value: "1",
                },
                {
                  name: "部门",
                  value: "2",
                },
                {
                  name: "岗位",
                  value: "3",
                },
              ];
              break;
            case 2: //部门
              this.addForm.orgType = "2";
              this.addForm.orgTypes = [
                {
                  name: "部门",
                  value: "2",
                },
                {
                  name: "岗位",
                  value: "3",
                },
              ];
              break;
            case 3: //岗位
              this.addForm.orgType = "3";
              this.addForm.orgTypes = [
                {
                  name: "岗位",
                  value: "3",
                },
              ];
              break;
          }
          break;
        case "confirmAdd": //确定添加
          if (this.addForm.name.length == "") {
            this.$message.closeAll();
            this.$message.error("请输入名称");
            return;
          }
          this.requestAdd();
          break;
        case "search": //点击搜索
          this.pageIndex = 1;
          this.total = 0;
          this.requestOrgList();
          break;
        case "edit": //编辑
          const item = this.multipleSelection[0];
          var orgTypes;
          if (item.orgType == 1) {
            orgTypes = [
              {
                name: "机构",
                value: "1",
              },
              {
                name: "部门",
                value: "2",
              },
              {
                name: "岗位",
                value: "3",
              },
            ];
          } else if (item.orgType == 2) {
            orgTypes = [
              {
                name: "部门",
                value: "2",
              },
              {
                name: "岗位",
                value: "3",
              },
            ];
          } else {
            orgTypes = [
              {
                name: "岗位",
                value: "3",
              },
            ];
          }
          this.editForm = {
            id: item.id,
            name: item.name,
            orgType: item.orgType + "",
            orgTypes: orgTypes,
          };
          this.dialogEditVisible = true;
          break;
        case "confirmEdit": //确认修改
          if (this.editForm.name.length == 0) {
            this.$message.closeAll();
            this.$message.error("请输入名称");
            return;
          }
          this.requestEdit();
          break;
        case "delete": //删除
          var _this = this;
          this.$confirm("此操作将删除所选机构, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              var ids = [];
              _this.multipleSelection.forEach((item) => {
                ids.push(item.id);
                if (item.id == _this.currentOrg.id) this.currentOrg = {};
              });
              if (ids.length == 0) {
                _this.$message.closeAll();
                _this.$message.error("未选择");
                return;
              }
              _this.requestDelete(ids);
            })
            .catch(() => {});
          break;
        case "resetOrg": //重置选中机构
          this.currentOrg = {
            id: "",
            name: "全部",
            orgType: 1,
            fullPathId: "",
          };
          this.requestOrgList();
          break;
      }
    },

    /**
     * 格式化日期
     */
    formatDate: function (str) {
      return str.substring(0, 10);
    },

    /**
     * 构造树形结构，且所有层级的节点都按中文拼音首字母排序
     * @param {Array} data 原始扁平数据
     * @returns {Array} 各层级均按拼音排序的树形结构
     */
    toTree: function (data) {
      // 1. 清空已有children，避免干扰
      data.forEach(function (item) {
        delete item.children;
      });

      // 2. 构建ID到节点的映射表
      var map = {};
      data.forEach(function (item) {
        map[item.id] = item;
      });

      // 3. 构建基础树形结构
      var treeData = [];
      data.forEach(function (item) {
        var parent = map[item.parentId];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          treeData.push(item);
        }
      });

      // 4. 递归排序「每一层级」的节点（按中文拼音首字母升序）
      var sortByChinesePinyin = function (nodes) {
        // 用JS内置的中文排序规则，直接按拼音排序（准确且无需手动提首字母）
        nodes.sort(function (a, b) {
          return a.name.localeCompare(b.name, "zh-CN");
        });
        // 递归排序子节点
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            sortByChinesePinyin(node.children);
          }
        });
      };

      sortByChinesePinyin(treeData);
      return treeData;
    },

    treeClick: function (node, nodeObj, comp) {
      this.currentOrg = {
        fullPathId: node.fullPathId,
        fullPathName: node.fullPathName,
        orgType: node.orgType,
        name: node.name,
        id: node.id,
      };
      this.pageIndex = 1;
      this.requestOrgList();
    },

    tableColumnCheckEvent: function (val) {
      this.multipleSelection = val;
      this.editDisable = val.length != 1;
      this.deleteDisable = val.length == 0;
    },

    /**
     * 翻页操作
     */
    handlePageChange: function (val) {
      this.pageIndex = val;
      this.requestOrgList();
    },

    /**
     * 查询左侧树列表
     */
    requestTreeData: function () {
      this.$get({
        url: "org/list",
        params: {},
      }).then((response) => {
        //递归解析tree数据
        this.tree = this.toTree(response);
      });
    },

    /**
     * 查询组织机构列表
     */
    requestOrgList: function () {
      this.$post(
        {
          url: "org/query",
          params: {
            keyWord: this.searchContent,
            fullPathId: this.currentOrg.fullPathId,
            isAll: true,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
          },
        },
        true
      ).then((response) => {
        this.total = response.total;
        this.tableData = response.data;
      });
    },

    /**
     * 新增组织机构
     */
    requestAdd: function () {
      this.$post(
        {
          url: "org/add",
          params: {
            name: this.addForm.name,
            orgType: parseInt(this.addForm.orgType),
            parentId: this.currentOrg.id,
          },
        },
        true
      ).then((response) => {
        this.$message.closeAll();
        this.$message.success("新增成功");
        this.dialogAddVisible = false;
        (this.addForm = {
          name: "",
          orgType: "1",
        }),
          this.requestTreeData();
        this.pageIndex = 1;
        this.requestOrgList();
      });
    },

    /**
     * 请求修改
     */
    requestEdit: function () {
      this.$post(
        {
          url: "org/edit",
          params: {
            id: this.editForm.id,
            name: this.editForm.name,
            orgType: parseInt(this.editForm.orgType),
          },
        },
        true
      ).then((response) => {
        this.dialogEditVisible = false;
        this.$message.closeAll();
        this.$message.success("修改成功");
        this.requestTreeData();
        this.pageIndex = 1;
        this.requestOrgList();
      });
    },

    /**
     * 删除组织机构
     */
    requestDelete: function (ids) {
      this.$post(
        {
          url: "org/delete",
          params: {
            ids: ids,
          },
        },
        true
      ).then((response) => {
        this.$message.closeAll();
        this.$message.success("删除成功");
        this.requestTreeData();
        this.pageIndex = 1;
        this.requestOrgList();
      });
    },
  },
};
